import { useEffect, useState } from "react";

/**
 * Czy jesteśmy na ekranie, na którym układy okienkowe mają sens (breakpoint `md`).
 * Poniżej: żadnych podziałów i żadnego pływaka — na telefonie rozmowa dostaje
 * cały ekran.
 */
export function useIsDesktop(): boolean {
  const [is, setIs] = useState(
    () => typeof window === "undefined" || window.matchMedia("(min-width: 768px)").matches,
  );
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const on = () => setIs(mq.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, []);
  return is;
}
